import React, { useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import OuraNav from "../components/OuraNav";
import TimesheetView from "../components/TimesheetView";
import SignaturePad from "../components/SignaturePad";
import fetchBase from "../utils/fetchBase";

const AdminTimesheetDetailPage = () => {
    const { id } = useParams();
    const [searchParams] = useSearchParams();
    const mode = searchParams.get("mode") === "created" ? "created" : "live";
    const [stage, setStage] = useState(null); // null | "name" | "sign"
    const [repName, setRepName] = useState("");
    const [refreshKey, setRefreshKey] = useState(0);
    const [saving, setSaving] = useState(false);
    const [repCompleted, setRepCompleted] = useState(false);

    const saveAgencyRep = async (signatureDataUrl) => {
        setSaving(true);
        try {
            const body = { agencyRepName: repName.trim() };
            if (signatureDataUrl) body.agencyRepSignature = signatureDataUrl;

            const res = await fetch(`${fetchBase}/time-log/timesheet/${id}/agency-rep`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + localStorage.getItem("jwt_token")
                },
                body: JSON.stringify(body)
            });

            if (!res.ok) {
                alert("Could not save. Please try again.");
                return;
            }

            setStage(null);
            setRepName("");
            setRefreshKey(k => k + 1);
        } catch (err) {
            console.error("Failed to save agency rep:", err);
            alert("Could not save. Please try again.");
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            <div className="no-print">
                <OuraNav links={[{ label: "Dashboard", href: "/admin-dashboard" }]} />
            </div>
            <div className="timesheet-page" style={{ maxWidth: "900px", margin: "0 auto", padding: "80px 20px 40px" }}>
                <style>{`
                    @page {
                        size: Letter portrait;
                        margin: 0.15in;
                    }

                    @media print {
                        .no-print {
                            display: none !important;
                        }

                        .timesheet-page {
                            padding: 0 !important;
                            margin: 0 !important;
                            zoom: 0.93;
                        }
                    }
                `}</style>
                    <div className="no-print" style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
                        <button
                            onClick={() => window.print()}
                            style={{ background: "#0071e3", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: "pointer" }}
                        >
                            Print / Save
                        </button>
                        <button
                            onClick={() => setStage("name")}
                            disabled={repCompleted}
                            style={{ background: repCompleted ? "#c7c7cc" : "#34c759", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: repCompleted ? "default" : "pointer" }}
                        >
                            {repCompleted ? "Completed" : "Complete"}
                        </button>
                    </div>

                        <TimesheetView key={refreshKey} timesheetId={id} mode={mode} onLoad={(d) => setRepCompleted(!!d.agencyRepName)} />
            </div>

            {stage === "name" && (
                <div className="no-print" style={{
                    position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh",
                    background: "rgba(0,0,0,0.5)", display: "flex", alignItems: "center",
                    justifyContent: "center", zIndex: 10000
                }}>
                    <div style={{ background: "#fff", borderRadius: "14px", padding: "20px", width: "340px" }}>
                        <p style={{ fontWeight: 700, fontSize: "15px", margin: "0 0 12px", color: "#1d1d1f" }}>
                            Agency Representative
                        </p>
                        <input
                            type="text"
                            value={repName}
                            onChange={(e) => setRepName(e.target.value)}
                            placeholder="Printed name"
                            style={{ width: "100%", boxSizing: "border-box", padding: "10px", fontSize: "14px", border: "1px solid #ccc", borderRadius: "8px", color: "#1d1d1f", background: "#fff" }}
                        />
                        <div style={{ display: "flex", flexDirection: "column", gap: "8px", marginTop: "14px" }}>
                            <button
                                onClick={() => setStage("sign")}
                                disabled={!repName.trim()}
                                style={{ background: repName.trim() ? "#0071e3" : "#a0c4e8", color: "#fff", border: "none", borderRadius: "8px", padding: "8px 16px", fontSize: "13px", fontWeight: 600, cursor: repName.trim() ? "pointer" : "default" }}
                            >
                                Next
                            </button>

                            <button
                                onClick={() => { setStage(null); setRepName(""); }}
                                style={{ background: "none", border: "none", color: "#6e6e73", fontSize: "13px", cursor: "pointer", padding: "6px" }}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {stage === "sign" && (
                <div className="no-print">
                    <SignaturePad
                        label={`Signature: ${repName.trim()}`}
                        onSave={saveAgencyRep}
                        onClose={() => setStage("name")}
                        saveLabel="Complete"
                        onSkip={() => saveAgencyRep(null)}
                        skipLabel="Skip"
                    />
                </div>
            )}
        </>
    );
};

export default AdminTimesheetDetailPage;